<template>
  <div
    class="w-100 h-100 p-3 overflow-auto bg-customize"
    :style="`background: rgba(${rGBaCode}); border-color: rgba(${rGBaCode})`"
  >
  <TtransitionPage v-if="isTtransitionPage"> </TtransitionPage>
      <div v-else :class="showPopup? '' : 'container mx-auto py-3 px-4 rounded shadow-custom mcf-light'" style="max-width:640px;"><!-- 遮罩 -->
  <McfFrameMobile >
    <template v-slot:content>
      <div class="container">
        <McfGetPointComplete
          class="my-4"
          v-if="showMcfGetPointComplete"
        ></McfGetPointComplete>

        <MaskLayer v-if="showPopup">
          <Popup
            v-if="showPopup"
            :confirmWording="$t('qrcode.back-to-membercenter')"
            @confirm="backToMembercenter"
            :display="{ close: false, cancel: false, confirm: true }"
            :rGBaCode="rGBaCode"
          >
            <h3 class="alert-heading">
              {{ popuptitle }}
            </h3>
            <p class="text-break-word font-size-md">
              {{ popupwording }}
            </p>
          </Popup>
        </MaskLayer>
      </div>
    </template>
  </McfFrameMobile>
      </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import format from 'date-fns/format';
import McfFrameMobile from '@/components/Mcf/McfFrameMobile.vue';
import McfGetPointComplete from '@/components/Mcf/McfGetPointComplete.vue';
import commonTool from '@/tools/commonTool';
import MaskLayer from '@/components/MaskLayer.vue';
import Popup from '@/components/Popup.vue';
import TtransitionPage from '@/components/Mcf/TtransitionPage.vue';
import mbcService from '@/services/mbcService';
import mcsService from '@/services/mcsService';
import sctService from '@/services/sctService';
import mmsService from '@/services/mmsService';

export default {
  data() {
    return {
      isNoMore: null,
      isTtransitionPage: false,
      showPopup: false,
      showMcfGetPointComplete: true,
      redirect_url: null,
      realUrl: null,
      customerShopUrl: null,
    };
  },
  components: {
    McfFrameMobile,
    McfGetPointComplete,
    MaskLayer,
    TtransitionPage,
    Popup,
  },
  created() {
    this.isTtransitionPage = true;
    this.getCoupon(this.couponNo);
    this.getMemberSourceSetting().then(() => {
      const vm = this;
      const { unionId } = vm.$route.query;
      const postCustomizeCouponActivityData = {
        sourceType: 2,
        source: vm.activityNo,
        loginType: 1,
        customerId: vm.memberId,
        couponNo: vm.couponNo,
        couponLimitCnt: vm.couponLimitCnt,
        unionId,
      };
      this.postCustomizeCouponActivity(postCustomizeCouponActivityData).then((res) => {
        if (res && res.response.success) {
          this.set({ name: 'limitEnd', value: res.response.data[0].limitEnd });

          this.getStore();
          this.showPopup = false;
        }
        this.isTtransitionPage = false;
      },
      (errorres) => {
        this.isTtransitionPage = false;
        this.showMcfGetPointComplete = false;
        switch (errorres.data.status) {
          case '733':
            // coupon 不足
            this.isNoMore = true;
            this.showPopup = true;
            mmsService.postSendMail({
              companyId: this.companyId,
              sendTo: 1,
              language: navigator.language.toLowerCase(),
              no: this.activityNo,
              activityName: this.activityName,
              couponName: this.couponName,
            })
              .toPromise();
            break;
          case '750':
            // coupon 超過領取數量
            this.isNoMore = false;
            this.showPopup = true;
            break;
          case '605':
            // coupon 不符合時時間或沒有資料
            this.isNoMore = true;
            this.showPopup = true;
            mmsService.postSendMail({
              companyId: this.companyId,
              sendTo: 2,
              language: navigator.language.toLowerCase(),
              no: this.activityNo,
              activityName: this.activityName,
              couponName: this.couponName,
            })
              .toPromise();
            break;
          default:
            // coupon 不符合時間
            this.isNoMore = true;
            this.showPopup = true;
            break;
        }
      });
    });
  },
  methods: {
    ...mapMutations(['set']),
    ...mapActions('pmt', ['getCoupon', 'postCustomizeCouponActivity']),
    ...mapActions('sso', ['getMemberSourceSetting', 'postDynamicLogin']),
    // 取得URL中的檔案名稱
    getFileNameFromUrl(url) {
      // eslint-disable-next-line newline-per-chained-call
      return url.split('#').shift().split('?').shift().split('/').pop();
    },
    backToMembercenter() {
      this.callDynamicLogin().then((res) => {
        if (res !== '') { window.location.assign(`${window.location.origin}/rewards/membercenter/notification?companyid=${this.companyId}&membersourceid=${this.memberSourceId}&code=${res}`); } else { window.location.assign(this.customerShopUrl); }
      });
    },

    callDynamicLogin() {
      const validData = {
        memberAcntNo: this.memberAcntNo,
        memberID: this.memberId,
      };

      if (commonTool.checkedMobile()) {
        validData.device = 'mobile';
      } else {
        validData.device = 'pc';
      }

      return this.postDynamicLogin(validData).then((res) => {
        if (res && res.response.success) {
          return res.response.data[0].code;
        }
        return '';
      })
        .catch(() => '');
    },
    getStore() {
      const { unionId } = this.$route.query;
      mmsService.postQrCodeScanningLog({
        unionId, type: 2, memberId: this.memberId,
      }).toPromise();

      const body = {
        companyId: this.companyId,
        customerId: this.memberId,
        customerType: 1,
        tagGroupType: 'ChatGroup',
      };
      mbcService.getCustomerTag(body)
        .then((res) => {
          if (res && res.response.success) {
            const companyTagNo = res.response.data[0] ? res.response.data[0].tags.find((s) => s.companyTagNo !== null).companyTagNo : null;
            const body2 = { companyTagNo };
            if (companyTagNo !== null) {
              mcsService.getagentservice(body2).then((res2) => {
                if (res2 && res2.response.success) {
                  this.getShopUrl(res2.response.data[0].agentServiceId);
                }
              }, () => this.getShopUrl());
            } else {
              this.getShopUrl();
            }
          }
        }, () => this.getShopUrl());
    },
    getShopUrl(agentServiceId) {
      sctService.getstore({ companyId: this.companyId, agentServiceId: '' })
        .toPromise()
        .then((getstoreres) => {
          if (getstoreres && getstoreres.response.data) {
            if (!agentServiceId) {
              this.goMainShop(getstoreres);
            } else {
              const ownShop = getstoreres.response.data.find((s) => s.agentServiceID === agentServiceId);
              if (ownShop === undefined) {
                this.goMainShop(getstoreres);
              } else {
                const goownshop = Array.isArray(ownShop) ? ownShop[0].url : ownShop.url;
                this.customerShopUrl = goownshop;
                this.sendNotice(goownshop);
              }
            }
          }
        });
    },
    goMainShop(getstoreres) {
      const mainShop = getstoreres.response.data.find((s) => s.isMain === true).url;
      this.customerShopUrl = mainShop;
      this.sendNotice(mainShop);
    },
    sendNotice(shopurl) {
      this.set({ name: 'customerShopUrl', value: shopurl });
      this.isTtransitionPage = false;
      const vm = this;
      const isOnline = vm.coupon.isOnline ? this.$t('qrcode.online') : '';
      const isOffline = vm.coupon.isOffline ? this.$t('qrcode.offline') : '';
      const dot = vm.coupon.isOffline && vm.coupon.isOffline ? '、' : '';
      let dynamicloginShopurl = shopurl;
      const range = isOnline + dot + isOffline;
      const isOfflineContent = vm.coupon.isOffline ? `<br><a href='${window.location.origin}/rewards/membercenter/mcfwallet?companyid=${this.companyId}&membersourceid=${this.memberSourceId}'>${this.$t('qrcode.go-check')}</a>` : '';
      this.callDynamicLogin().then((res) => {
        if (res !== '') {
          dynamicloginShopurl = `${shopurl}Plugins/SSOAuth/LoginCallback?code=${res}`;
        }
      })
        .finally(() => {
          const isOnlineContent = vm.coupon.isOnline ? `<br><a href='${dynamicloginShopurl}'>${this.$t('qrcode.go-shopping')}</a>` : '';
          let content = this.$t('qrcode.congratulations-content', { range, date: `${format(this.limitEnd, 'yyyy/MM/dd HH:mm')} ${this.$t('qrcode.end')}` });
          if (vm.coupon.limitType === 0) {
            content = this.$t('qrcode.congratulations-content', { range, date: this.$t('qrcode.no-limit') });
          }

          const body = {
            compnayID: this.companyId,
            noticeInfo: [
              {
                memberID: [this.memberId],
                title: `${this.$t('qrcode.congratulations')}${vm.couponName}`,
                content: `${content}${isOnlineContent}${isOfflineContent}`,
                attachmentUrl: vm.couponImage,
                attachmentName: vm.getFileNameFromUrl(vm.couponImage),
              },
            ],
          };
          mbcService.postMemberNotice(body);
        });
    },
  },
  computed: {
    ...mapState(['memberAcntNo', 'memberId', 'companyId', 'memberSourceId', 'couponLimitCnt', 'activityNo', 'couponNo', 'limitEnd', 'couponName', 'couponImage', 'activityName']),
    ...mapState('pmt', ['coupon']),
    ...mapState('sso', ['rGBaCode']),
    popuptitle() {
      if (this.isNoMore) {
        return this.$t('qrcode.nomore-coupon-title');
      }
      return this.$t('qrcode.coupon-upper-imit-title');
    },
    popupwording() {
      if (this.isNoMore) {
        return this.$t('qrcode.nomore-coupon-wording', { count: this.couponLimitCnt });
      }
      return this.$t('qrcode.coupon-upper-imit-wording', { count: this.couponLimitCnt });
    },
  },
};
</script>

<style>
</style>
